const Button = ({ type, children, disabled, onClick, title }) => {
	return (
		<button className={`btn btn--${type ? type : ''}`} type='button' onClick={onClick} disabled={disabled ? disabled : ''} title={title}>
			{children}
		</button>
	);
};

export default Button;
